import { Button } from '@bloomfieldrobotics/canopy';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Paper, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import {
  selectDebugCollectionIdSearch,
  setDebugCurrCollectionId,
} from '../debugSlice';
import { CollectionDebugRefreshButton } from './ColllectionDebugRefreshButton';
import { SearchCollection } from './SearchCollection';
/**
 * A header component for searching collections by ID
 * Styled consistently with other debug info sections
 */
export const SearchCollectionHeader = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const searchCollectionId = useAppSelector(selectDebugCollectionIdSearch);

  const handleSearch = () => {
    dispatch(setDebugCurrCollectionId(searchCollectionId));
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Paper
      variant='outlined'
      sx={{
        backgroundColor: theme.vars.palette.background.default,
        borderRadius: 1,
        mb: 3,
        boxShadow: 1,
        border: `1px solid ${theme.vars.palette.divider}`,
        overflow: 'hidden', // Ensures the divider doesn't overflow
      }}
      onKeyDown={handleKeyDown}
    >
      {/* Header section with title */}
      <Box
        sx={{
          p: 3,
          backgroundColor: theme.vars.palette.background.default,
          borderBottom: `1px solid ${theme.vars.palette.divider}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h6' fontWeight='medium'>
          {t('Debug Tools')}
        </Typography>
        <CollectionDebugRefreshButton />
      </Box>

      {/* Search section */}
      <Box sx={{ p: 3 }}>
        <Typography
          variant='subtitle2'
          fontWeight='medium'
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 1.5,
            color: theme.vars.palette.text.secondary,
          }}
        >
          <SearchIcon sx={{ mr: 1, fontSize: 18 }} />
          {t('Search By Collection ID')}
        </Typography>

        <Stack direction='row' spacing={1} alignItems='center'>
          <SearchCollection />
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={handleSearch}
          >
            {t('Search')}
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
};
